import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=44cd8f7c"
import script from "./Notification.vue?vue&type=script&lang=js"
export * from "./Notification.vue?vue&type=script&lang=js"
import style0 from "./Notification.vue?vue&type=style&index=0&id=44cd8f7c&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('44cd8f7c')) {
      api.createRecord('44cd8f7c', component.options)
    } else {
      api.reload('44cd8f7c', component.options)
    }
    module.hot.accept("./Notification.vue?vue&type=template&id=44cd8f7c", function () {
      api.rerender('44cd8f7c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NotificationPlugin/Notification.vue"
export default component.exports